const USERS = (state, users) => {
    state.users = users;
};



export default {
    USERS,
};